module.exports = __webpack_public_path__ + "img/blood-transparent@2x.71636954.png";